import { ComparePlanTableColumnHeader } from "./comparePlanTableColumnHeader.component";
import type { SanityPlanCompareColumn } from "./useComparePlanTableSectionState";

export const ComparePlanTableColumnHeaders = ({
  columns,
  gridTemplateColumns,
}: ComparePlanTableColumnHeadersProps) => {
  if (!columns.length) return null;

  const mobileGridTemplateColumns = `repeat(${columns.length}, minmax(0, 1fr))`;

  return (
    <div
      data-testid="compare-plan-table-column-headers"
      className="w-full"
      role="row">
      <div
        data-testid="compare-plan-table-column-headers-mobile"
        role="columnheader"
        className="grid items-end gap-2 lg:hidden"
        style={{ gridTemplateColumns: mobileGridTemplateColumns }}>
        {columns.map((column) => (
          <ComparePlanTableColumnHeader
            key={column.id}
            column={column}
            layout="mobile"
          />
        ))}
      </div>

      <div
        data-testid="compare-plan-table-column-headers-desktop"
        role="columnheader"
        className="scrollbar-hide hidden min-w-0 overflow-x-auto lg:grid"
        style={{ gridTemplateColumns }}>
        <div aria-hidden="true" />
        {columns.map((column) => (
          <ComparePlanTableColumnHeader
            key={`desktop-${column.id}`}
            column={column}
            layout="desktop"
          />
        ))}
      </div>
    </div>
  );
};

type ComparePlanTableColumnHeadersProps = {
  columns: SanityPlanCompareColumn[];
  gridTemplateColumns: string;
};
